const metaData = [
  {
    id: 8696054612181,
    name: "looi robot",
    notice: "",
    variants: [
      {
        name: "looi robot * 1",
        id: 49092007624917,
        remark: "LOOI Robot × 1, LOOI Docking Ring × 1, USB-C Cable × 1",
           tag: "SAVE $20 Now",
      },
      {
        name: "looi robot * 2",
        id: 49092007690453,
        remark: "LOOI Robot × 2, LOOI Docking Ring × 2, USB-C Cable × 2",
      },
    ],
  },
];

/**
 * 获取metaData
 * @param {*} id
 * @param {*} childId
 * @returns
 */
function getMetaData(id, childId) {
  if (id && childId) {
    const variant = metaData.find((item) => item.id === id);
    const variantItem = variant.variants.find((item) => item.id === childId);
    return variantItem.remark;
  }
  return "";
}
function getMetaDataTag(id, childId) {
  if (id && childId) {
    const variant = metaData.find((item) => item.id === id);
    const variantItem = variant.variants.find((item) => item.id === childId);
    return variantItem.tag;
  }
  return "";
}
function getMetaDataNotice(id) {
  if (id) {
    const variant = metaData.find((item) => item.id === id);
    if(variant){
      return variant.notice
    }
    return "";
  }
  return "";
}

window.getMetaData = getMetaData;
window.getMetaDataTag = getMetaDataTag;
window.getMetaDataNotice = getMetaDataNotice;
